import { SxProps } from "@mui/material";
import { ThemeV2 } from "../../util/types";

export const portraitListContainer: SxProps = {
  maxWidth: "100%",
  minWidth: "85vw",
  display: "flex",
  flexDirection: "column",
  paddingX: { xs: 2, md: 3 },
  paddingBottom: 2,
  paddingTop: 1,
};

export const portraitRowSection = (theme: ThemeV2): SxProps => ({
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  paddingBottom: 2,
  borderBottom: `1px solid ${theme.tokens.color.border}`,
  "&:last-of-type": {
    borderBottom: "none",
    paddingBottom: 0,
  },
});

export const portraitRowHeader: SxProps = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  flexWrap: "wrap",
};

export const portraitOptionList: SxProps = {
  display: "flex",
  flexDirection: "column",
  gap: 0.5,
};

export const portraitOptionRow = (disabled: boolean): SxProps => ({
  display: "flex",
  alignItems: "center",
  gap: 1,
  minHeight: 40,
  opacity: disabled ? 0.5 : 1,
});
